import { useMemo, useRef } from 'react'

import { SubNavbar } from '@joor/design-system'
import styled from 'styled-components/macro'

import { JoorPayOrders } from './components'
import { TableRowData } from './components/JoorPayOrders/joorPayOrders.types'
import { messages } from './constants/messages'
import { ListTab, useTabs } from './listView.hooks'
import { HeaderIds } from 'containers/OrderList/OrderList.ids'

export function ListView({ allOrdersContent, initialTab }: ListProps) {
  const { activeTabIndex, handleAllOrdersTab, handleJoorPayOrdersTab } =
    useTabs(initialTab)

  const syncedUpdatedRows = useRef<SyncedRows>(new Map())
  const handleUpdateRows = (updatedRows: TableRowData[]) => {
    const currentRows = syncedUpdatedRows.current
    updatedRows.forEach((row) => {
      currentRows.set(row.id, row)
    })
    syncedUpdatedRows.current = currentRows
  }

  const tabs = useMemo(
    () => [
      {
        id: HeaderIds.AllOrdersTab,
        label: messages.allOrdersLabel,
        component: () => allOrdersContent,
        onClick: handleAllOrdersTab,
      },
      {
        id: HeaderIds.JoorPayTab,
        label: messages.payOrdersLabel,
        component: () => (
          <JoorPayOrders
            onChangeToAllOrdersTab={handleAllOrdersTab}
            rowsToSync={syncedUpdatedRows.current}
            onUpdateRows={handleUpdateRows}
          />
        ),
        onClick: handleJoorPayOrdersTab,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  )

  const Content = tabs[activeTabIndex].component

  return (
    <ListContainer>
      <SubNavbarContainer>
        <SubNavbar index={activeTabIndex} tabs={tabs} />
      </SubNavbarContainer>
      <ContentContainer>
        <Content />
      </ContentContainer>
    </ListContainer>
  )
}

type ListProps = {
  allOrdersContent: JSX.Element
  initialTab?: ListTab
}

export type SyncedRows = Map<string, TableRowData>

const ListContainer = styled.div`
  margin-top: -25px;
`

const SubNavbarContainer = styled.div`
  & > div {
    padding-left: 20px;
    gap: 20px;
  }
`

const ContentContainer = styled.div`
  height: calc(100vh - 100px);
  overflow: hidden;
  padding-top: 6px;
`
